"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const COMPASS_AMBER = "#B5680A";

const CompassDashboardProblemSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, sm: 7, md: 10 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 4, md: 6, lg: 8 },
            alignItems: "start",
          }}
        >
          {/* Left - Label + Heading */}
          <Box>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "11px" },
                fontWeight: 600,
                color: COMPASS_AMBER,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                lineHeight: 1.5,
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
                maxWidth: 360,
              }}
            >
              {t("compassDashboardProblem.label")}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "26px", sm: "30px", md: "34px", lg: "38px" },
                fontWeight: 700,
                lineHeight: 1.2,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("compassDashboardProblem.heading")}
            </Typography>
          </Box>

          {/* Right - Paragraph with amber line */}
          <Box
            sx={{
              [isArabic ? "borderRight" : "borderLeft"]: `2px solid #D4790B`,
              [isArabic ? "pr" : "pl"]: { xs: 2.5, sm: 3, md: 4 },
              py: { xs: 0, md: 0.5 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "15px" },
                color: "#3E3E56",
                lineHeight: 1.8,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("compassDashboardProblem.paragraph")}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CompassDashboardProblemSection;